import { UserProfileSectionWrapper } from './styledComponents'

export const GET_PROJECT_MEMBERS = 'app/TeamsManagement/GET_PROJECT_MEMBERS'
export const GET_PROJECT_MEMBERS_DONE =
  'app/TeamsManagement/GET_PROJECT_MEMBERS_DONE'
export const GET_PROJECT_MEMBERS_ERROR =
  'app/TeamsManagement/GET_PROJECT_MEMBERS_ERROR'

export const SET_MEMBER_INACTIVE = 'app/TeamsManagement/SET_MEMBER_INACTIVE'
export const SET_MEMBER_INACTIVE_ERROR =
  'app/TeamsManagement/SET_MEMBER_INACTIVE_ERROR'

export const SET_MEMBER_ACTIVE = 'app/TeamsManagement/SET_MEMBER_ACTIVE'
export const SET_MEMBER_ACTIVE_ERROR =
  'app/TeamsManagement/SET_MEMBER_ACTIVE_ERROR'

export const UPDATE_PROJECT_MEMBER = 'app/TeamsManagement/UPDATE_PROJECT_MEMBER'
export const UPDATE_PROJECT_MEMBER_DONE =
  'app/TeamsManagement/UPDATE_PROJECT_MEMBER_DONE'
export const UPDATE_PROJECT_MEMBER_ERROR =
  'app/TeamsManagement/UPDATE_PROJECT_MEMBER_ERROR'

export const CREATE_TEAM = 'app/TeamsManagement/CREATE_TEAM'
export const CREATE_TEAM_DONE = 'app/TeamsManagement/CREATE_TEAM_DONE'
export const CREATE_TEAM_ERROR = 'app/TeamsManagement/CREATE_TEAM_ERROR'

export const GET_TEAM = 'app/TeamsManagement/GET_TEAM'
export const GET_TEAM_DONE = 'app/TeamsManagement/GET_TEAM_DONE'
export const GET_TEAM_ERROR = 'app/TeamsManagement/GET_TEAM_ERROR'

export const GET_TEAMS = 'app/TeamsManagement/GET_TEAMS'
export const GET_TEAMS_ALL_PAGES = 'app/TeamsManagement/GET_TEAMS_ALL_PAGES'
export const GET_TEAMS_DONE = 'app/TeamsManagement/GET_TEAMS_DONE'
export const GET_TEAMS_ERROR = 'app/TeamsManagement/GET_TEAMS_ERROR'

export const SET_TEAM_INACTIVE = 'app/TeamsManagement/SET_TEAM_INACTIVE'
export const SET_TEAM_INACTIVE_DONE =
  'app/TeamsManagement/SET_TEAM_INACTIVE_DONE'
export const SET_TEAM_INACTIVE_ERROR =
  'app/TeamsManagement/SET_TEAM_INACTIVE_ERROR'

export const UPDATE_TEAM = 'app/TeamsManagement/UPDATE_TEAM'
export const UPDATE_TEAM_DONE = 'app/TeamsManagement/UPDATE_TEAM_DONE'
export const UPDATE_TEAM_ERROR = 'app/TeamsManagement/UPDATE_TEAM_ERROR'

export const ADD_TEAM_MEMBERS = 'app/TeamsManagement/ADD_TEAM_MEMBERS'
export const ADD_TEAM_MEMBERS_DONE = 'app/TeamsManagement/ADD_TEAM_MEMBERS_DONE'
export const ADD_TEAM_MEMBERS_ERROR =
  'app/TeamsManagement/ADD_TEAM_MEMBERS_ERROR'

export const REMOVE_TEAM_MEMBERS = 'app/TeamsManagement/REMOVE_TEAM_MEMBERS'
export const REMOVE_TEAM_MEMBERS_DONE =
  'app/TeamsManagement/REMOVE_TEAM_MEMBERS_DONE'
export const REMOVE_TEAM_MEMBERS_ERROR =
  'app/TeamsManagement/REMOVE_TEAM_MEMBERS_ERROR'

export const GET_SUGGESTED_MEMBERS = 'app/TeamsManagement/GET_SUGGESTED_MEMBERS'
export const GET_SUGGESTED_MEMBERS_DONE =
  'app/TeamsManagement/GET_SUGGESTED_MEMBERS_DONE'
export const GET_SUGGESTED_MEMBERS_ERROR =
  'app/TeamsManagement/GET_SUGGESTED_MEMBERS_ERROR'

export const INVITE_TEAM_MEMBER = 'app/TeamsManagement/INVITE_TEAM_MEMBER'
export const INVITE_TEAM_MEMBER_DONE =
  'app/TeamsManagement/INVITE_TEAM_MEMBER_DONE'
export const INVITE_TEAM_MEMBER_ERROR =
  'app/TeamsManagement/INVITE_TEAM_MEMBER_ERROR'
export const INVITE_TEAM_MEMBER_ERROR_CLEAR =
  'app/TeamsManagement/INVITE_TEAM_MEMBER_ERROR_CLEAR'

export const UPDATE_MEMBER_ROLE = 'app/TeamsManagement/UPDATE_MEMBER_ROLE'
export const UPDATE_MEMBER_ROLE_DONE =
  'app/TeamsManagement/UPDATE_MEMBER_ROLE_DONE'
export const UPDATE_MEMBER_ROLE_ERROR =
  'app/TeamsManagement/UPDATE_MEMBER_ROLE_ERROR'
export const DISMISS_MEMBER_ROLE_ERROR =
  'app/TeamsManagement/DISMISS_MEMBER_ROLE_ERROR'

export const TOGGLE_NAME_TAKEN_POPUP =
  'app/TeamsManagement/TOGGLE_NAME_TAKEN_POPUP'
export const TOGGLE_CREATE_TEAM_POPUP =
  'app/TeamsManagement/TOGGLE_CREATE_TEAM_POPUP'
export const TOGGLE_EDIT_TEAM_POPUP =
  'app/TeamsManagement/TOGGLE_EDIT_TEAM_POPUP'
export const TOGGLE_INVITE_MEMBER_POPUP =
  'app/TeamsManagement/TOGGLE_INVITE_MEMBER_POPUP'

// get team user
export const GET_MEMBERSHIP_USER = 'app/TeamsManagement/GET_MEMBERSHIP_USER'
export const GET_MEMBERSHIP_USER_DONE =
  'app/TeamsManagement/GET_MEMBERSHIP_USER_DONE'
export const GET_MEMBERSHIP_USER_ERROR =
  'app/TeamsManagement/GET_MEMBERSHIP_USER_ERROR'

export const SECTION_TYPES = {
  USER_PROFILE: {
    wrapper: UserProfileSectionWrapper
  },
  PROFILE_PICTURE: 'PROFILE_PICTURE'
}

export const FIELD_TYPES = {
  DROPDOWN: 1,
  ROLES: 2,
  SELECT: 3,
  PROFILE_PICTURE: 4,
  PROFILE_PICTURE_DROPZONE: 5
}

export const ROLES = {
  SUBCONTRACTOR: 'SubContractor',
  VIEWER: 'Viewer',
  POWERUSER: 'PowerUser',
  ASSISTANT: 'Assistant',
  EXTERNALVISITOR: 'ExternalVisitor'
}

export const ROLE_PERMISSION_URL = {
  de: 'https://intercom-help.eu/docu-tools-helpcenter/de/articles/277779-projektmitglieder-und-rollen',
  en: 'https://intercom-help.eu/docu-tools-helpcenter/en/articles/277779-project-members-and-roles'
}
